/* HALO Team (/pages/team): Einblendung und Parallax aus dem Original team.halo-academy.com.
   Der Header-Farbwechsel des Originals entfaellt, die Seite nutzt den Shop-Header.
   Inhalte sind ohne Skript sichtbar; erst hier wird .hteam--js gesetzt. */
(function(){
  var root=document.querySelector('.hteam');
  if(!root) return;

  var hdr=document.querySelector('[data-halo-header]');
  function anchorOffset(){ if(hdr){ root.style.setProperty('--hteam-anchor',(hdr.offsetHeight+8)+'px'); } }
  anchorOffset();
  window.addEventListener('resize',anchorOffset);

  if('IntersectionObserver' in window){
    root.classList.add('hteam--js');
    var io=new IntersectionObserver(function(e){e.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);}});},{threshold:0.12,rootMargin:'0px 0px -8% 0px'});
    root.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
  }

  var pxEls=[].slice.call(root.querySelectorAll('.px[data-px]'));
  var ticking=false;
  function parallax(){
    var vh=window.innerHeight;
    for(var i=0;i<pxEls.length;i++){
      var el=pxEls[i];
      var host=el.parentElement;var r=host.getBoundingClientRect();
      if(r.bottom<-400||r.top>vh+400) continue;
      var hostH=host.offsetHeight;var overhang=(el.offsetHeight-hostH)/2;
      var center=r.top+hostH/2;var prog=(center-vh/2)/vh;
      var strength=(parseFloat(el.dataset.px)||14)/100;
      var shift=prog*strength*hostH;
      if(shift>overhang)shift=overhang;else if(shift<-overhang)shift=-overhang;
      el.style.transform='translate3d(0,'+shift.toFixed(1)+'px,0)';
    }
    ticking=false;
  }
  function onScrollPx(){if(!ticking){ticking=true;requestAnimationFrame(parallax);}}
  window.addEventListener('scroll',onScrollPx,{passive:true});
  window.addEventListener('resize',onScrollPx);parallax();
})();
